exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".upload-wrapper .img-wrap[data-v-6c1c6d48]{position:relative;width:100%;height:180px;line-height:180px;border:1px solid #c0ccda;border-radius:4px;text-align:center}.upload-wrapper .img-wrap img[data-v-6c1c6d48],.upload-wrapper .img-wrap video[data-v-6c1c6d48]{position:absolute;left:0;right:0;top:0;bottom:0;width:100%;height:100%;object-fit:contain}.upload-wrapper .img-wrap .file-name[data-v-6c1c6d48]{width:100%;height:100%;text-align:center;display:flex;justify-content:center;align-items:center}.upload-wrapper .img-close[data-v-6c1c6d48]{position:absolute;top:0;right:0;padding:0}.upload-wrapper .upload-tips[data-v-6c1c6d48]{text-align:left!important;line-height:1;margin:0}.el-dragger__text[data-v-6c1c6d48]{padding:0 20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-6c1c6d48&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/UploadItems/UploadItem.vue
// module id = 567
// module chunks = 0